import type { FaireProductEntity } from "../../entity_types/product";

export const p_322uz8qbeh: FaireProductEntity = {
  token: "p_322uz8qbeh",
  type: "product",
  name: "Sterling Silver 3.0ct Oval Moissanite Cluster Vintage 3 Piece Ring Set",
  brandToken: "b_75net88q84",
  brandName: "Atlanta Jewelers Supply",
  imageUrl:
    "https://cdn.faire.com/fastly/f73ba2d7b760cfcbbcb4d7f5d637841ae478d0168a9276fa9de15ba0417d1107.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c0646fea6f6f76d60d301c98be087bdcc5f04d59c249b1ab64019f58726b11de.jpeg",
    "https://cdn.faire.com/fastly/35cba656f0e16e134266b0e703d75ce082c9c90dc2a390ce02f8c8323e2c837e.jpeg",
    "https://cdn.faire.com/fastly/24861cfd5a4bc6fc3ad7a41104530a9825db39943c5e10a360dcc3e74ef7594d.jpeg",
  ],
  priceDollars: 96.98,
  description:
    "This exquisite ring set features a striking 3.0ct oval moissanite solitaire set in sterling silver, with an option for 14k gold plating to enhance its elegance. Measuring 10mm by 8mm, the main stone is beautifully complemented by two cluster moissanite bands that surround it, creating an intricate vintage floral design. Perfectly balancing sophistication and timeless charm, this three-piece set offers a unique statement with exceptional sparkle and craftsmanship.\n",
  tags: [],
  msrpDollars: 193.97,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:58:54.874Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
